import React, { useState } from 'react';
import styles from '../../CardsAndWallets.module.scss';
import { Menu, MenuItem, styled } from '@mui/material';
import { Button, Input } from 'tt-ui-lib/core';
import {
  CopyIcon,
  StarIcon,
  AddIcon,
  SearchIcon,
  LitterBinIcon,
  ChatSupportIcon,
  ActiveWalletIcon,
  BlockedWalletIcon,
  FrozenWalletIcon,
} from 'tt-ui-lib/icons';
import Switch from '@mui/material/Switch';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 40,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 4,
    transitionDuration: '300ms',
    color: '#555555',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#ffffff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#18397A',
        opacity: 1,
        border: '1px solid #18397A',
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#18397A',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 16,
    height: 16,
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    backgroundColor: 'transparent',
    border: '1px solid #555555',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const FAKE_WALLETS = [
  {
    id: 1,
    wallet_address: '01...0xb8cd0xb8c0xb8cd0xb8cd',
    status: 'active',
    connectDate: '23.04.2023',
  },
  {
    id: 2,
    wallet_address: '01...0xb8cd0xb8c0xb8cd0xb8cd',
    status: 'active',
    connectDate: '23.04.2023',
  },
  {
    id: 3,
    wallet_address: '01...0xb8cd0xb8c0xb8cd0xb8cd',
    status: 'frozen',
    connectDate: '23.04.2023',
  },
  {
    id: 4,
    wallet_address: '01...0xb8cd0xb8c0xb8cd0xb8cd',
    status: 'blocked',
    connectDate: '23.04.2023',
  },
];
const statusOptions = {
  active: {
    icon: <ActiveWalletIcon style={{ width: 20, height: 20 }} />,
    options: [
      {
        title: 'Copy address',
        icon: <CopyIcon style={{ width: 20, height: 20 }} />,
      },
      {
        title: 'Freeze wallet',
        icon: <LitterBinIcon style={{ width: 20, height: 20 }} />,
      },
      {
        title: 'Set as default',
        icon: <StarIcon style={{ width: 20, height: 20 }} />,
      },
      {
        title: 'Block wallet & delete info',
        icon: <LitterBinIcon style={{ width: 20, height: 20 }} />,
      },
    ],
  },
  frozen: {
    icon: <FrozenWalletIcon style={{ width: 20, height: 20 }} />,
    options: [
      {
        title: 'Copy address',
        icon: <CopyIcon style={{ width: 20, height: 20 }} />,
      },
      {
        title: 'Freeze wallet',
        icon: <LitterBinIcon style={{ width: 20, height: 20 }} />,
      },
    ],
  },
  blocked: {
    icon: <BlockedWalletIcon style={{ width: 20, height: 20 }} />,
    options: [
      {
        title: 'Copy address',
        icon: <CopyIcon style={{ width: 20, height: 20 }} />,
      },
      {
        title: 'Support',
        icon: <ChatSupportIcon style={{ width: 20, height: 20 }} />,
      },
    ],
  },
};

const WalletsList = () => {
  const [searchValue, setSearchValue] = useState();
  const [walletsList, setWalletsList] = useState(FAKE_WALLETS);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const openOptions = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const StyledMenu = styled((props) => (
    <Menu
      id="pickup-options-menu"
      anchorEl={anchorEl}
      open={openOptions}
      onClose={handleClose}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      boxShadow: '0px 4px 32px rgba(0, 0, 0, 0.08)',
      borderRadius: '12px',
      '& .MuiMenu-list': {},
    },
  }));

  const handleClick = (event, walletId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setActiveItem(walletId);
  };

  return (
    <div className={styles.contentBoxWallet}>
      <div className={styles.search}>
        <Input
          className={styles.searchInput}
          label="Search"
          prefix={<SearchIcon style={{ width: 20, height: 20 }} />}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
          value={searchValue}
        />
        <Button type="primary" className={styles.addWalletBtn}>
          <AddIcon style={{ width: 24, height: 24 }} />
          Connect wallet
        </Button>
      </div>
      <div className={styles.titleAndSwitch}>
        <div className={styles.title}>Connected wallets</div>
        <div className={styles.switchBlock}>
          <IOSSwitch sx={{ m: 1 }} />
          <div className={styles.text}>
            Active wallets <span className={styles.desktopText}>only</span>
          </div>
        </div>
      </div>
      {walletsList.length > 0 &&
        walletsList.map((wallet) => (
          <div className={styles.walletItem}>
            <div className={styles.walletAddress}>
              {statusOptions[wallet.status].icon}
              <div className={styles.address}>{wallet.wallet_address}</div>
            </div>
            <div className={styles.connectDate}>Connect date: {wallet.connectDate}</div>
            <div className={styles.optionsIcon} onClick={(e) => handleClick(e, wallet.id)}>
              <MoreVertIcon />
            </div>
            {activeItem === wallet.id && (
              <StyledMenu>
                {statusOptions[wallet.status].options.map((option) => (
                  <MenuItem className={styles.menuItemWrapper}>
                    {option.icon}
                    <div>{option.title}</div>
                  </MenuItem>
                ))}
              </StyledMenu>
            )}
          </div>
        ))}
    </div>
  );
};

export default WalletsList;
